import { setFevoriteApi, deleteFevoriteApi, favoriteListApi, getPromotionListApi, getPopularListApi, axiosGetGameInfo } from '../../api/apiIndex'
import { Message } from 'element-ui';
import i18n from "../../utils/lang/index.js";

export default {
  state: {
    gameList: [],
    originGameList: [],
    favorite: {
      game_id: null,
      member_id: null,
    },
    favoriteList: [],
    currentSelected: 0
  },
  getters: {},
  mutations: {
    setGameList(state, data) {
      state.gameList = data;
    },
    setOriginGameList(state, data){
      state.originGameList = data;
    },
    setFavoriteGame(state, data) {
      state.favorite = data;
    },
    setFavoriteList(state, data) {
      state.favoriteList = data;
    },
    setCurrentSelected(state, index) {
      state.currentSelected = index;
    }
  },
  actions: {
    getGameList(context) {
      context.commit("setGameList", context.state.originGameList);
    },
    getPopularList(context, params) {
      getPopularListApi(params).then(res => {
        context.commit("setGameList", res.data);
      })
      .catch(err => {
        Message.error(err.response.data.message);
      });
    },
    getPromotionList(context, params) {
      getPromotionListApi(params).then(res => {
        context.commit("setGameList", res.data);
      })
      .catch(err => {
        Message.error(err.response.data.message);
      });
    },
    getFavoriteList(context, params) {
      favoriteListApi(params).then(res => {
        context.commit("setFavoriteList", res.data);
      }).catch(err => {
        Message.error("Error in setting favorite list", err);
      })
    },
    setFavoriteGame(context, data) {
      setFevoriteApi(data).then(res => {
        if (res.code === 200) {
          context.dispatch("getFavoriteList", {member_id: data.member_id, name: ''});
        }
      }).catch(err => {
        Message.error("Error in setting favorite", err);
      })
    },
    removeFavoriteGame(context, data) {
      deleteFevoriteApi(data).then(res => {
        if (res.code === 200) {
          context.dispatch("getFavoriteList", {member_id: data.member_id, name: ''});
        }
      }).catch(err => {
        Message.error("Error in setting favorite", err);
      })
    },
  }
}


// WEBPACK FOOTER //
// ./src/vuex/modules/games.js